export default __webpack_public_path__ + "static/media/p7.23c0ebbe.jpg";